import * as LDClient from 'launchdarkly-js-client-sdk';

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig().public;
  const e2eVisualTest = !!config.e2eVisualTest;

  if (e2eVisualTest) {
    const mockLdClient = {
      variation: async (_flag, defaultValue) => defaultValue,
    };
    return {
      provide: {ldClient: mockLdClient},
    };
  }

  const clientSideId = config.launchDarklyClientSideId;

  let client = null;
  let initializationPromise = null;

  const initializeLDClient = async () => {
    if (initializationPromise) return initializationPromise;

    initializationPromise = (async () => {
      try {
        const org = useState('org');

        if (org.value?.id) {
          const context = {
            kind: 'organization',
            key: org.value.id,
            name: org.value.name,
          };

          client = LDClient.initialize(clientSideId, context);
          try {
            await client.waitForInitialization();
          } catch (error) {
            console.error('Failed waiting for LaunchDarkly client to initialize:', error);
            initializationPromise = null;
            return null;
          }
        } else {
          throw new Error('Unable to initialize LaunchDarkly: No organization data');
        }
      } catch (error) {
        console.error('Error initializing LaunchDarkly client:', error);
        initializationPromise = null;
        return null;
      }
    })();

    return initializationPromise;
  };

  const getClient = async () => {
    try {
      if (!client) {
        await initializeLDClient();
      }
      return client;
    } catch (err) {
      console.error('[LaunchDarkly] Error in getClient:', err);
      throw err;
    }
  };

  return {
    provide: {
      ldClient: new Proxy(
        {},
        {
          get: (target, prop) => {
            return async (...args) => {
              try {
                const ldClient = await getClient();
                if (!ldClient) {
                  throw new Error('LaunchDarkly client is not initialized');
                }
                return ldClient[prop](...args);
              } catch (err) {
                console.error(`[LaunchDarkly] Error calling method "${prop}":`, err);
                throw err;
              }
            };
          },
        }
      ),
    },
  };
});
